export default "/images/plan-recuperacion-logo.png?71ca75ec039eb5db1c566ce2ab354c53";